import React from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import logo from '../../assets/endebet-white.svg'

export default function Navbar() {
    return (
        <div className='navbar'>
            <div className="navContainer">
                <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
                    <img src={logo} className='logo' />
                </Link>
                <div className="navItems">
                    <Link to="/login">
                        <button class="text-blue-800 bg-slate-300 border-0 py-0 px-4 focus:outline-none  rounded text-lg m-5">Login</button>
                    </Link>
                    <button class="text-blue-800 bg-slate-300 border-0 py-0 px-4 focus:outline-non rounded text-lg">Register</button>
                </div>
            </div>
        </div>
    )
} 
